"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const genericLayoutTitleInputs = [
  {
    name: "title",
    type: "string",
    defaultValue: "Transform Your Ploom Look",
  },
  {
    name: "secondaryTitle",
    type: "string",
    defaultValue: "FRONT PANELS, BACK COVERS, & CARRY CASES",
  },
  {
    name: "description",
    type: "richText",
    defaultValue:
      "Transform your Ploom look with our new front panels, back covers, and carry cases. Available in a variety of colors and styles to suit your style.",
  },
  {
    name: "reverseOrder",
    type: "boolean",
    defaultValue: false,
    helperText: "Reverse the order of the title and secondaryTitle",
  },
] as const satisfies Inputs;

export const GenericLayoutTitleComponent: RegisteredComponent = {
  name: "GenericLayoutTitle",
  component: dynamic(async () =>
    withValidation(
      genericLayoutTitleInputs,
      (await import("./GenericLayoutTitle")).GenericLayoutTitle,
      "GenericLayoutTitle"
    )
  ),
  inputs: genericLayoutTitleInputs,
};
